var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import sort, { stringSort } from "@domains/utils/sort";
export var productDataMapper = function (data, req) {
    var result = [];
    if (data && data.length > 0) {
        var product = Array.from(new Set(data.map(function (item) { return item.product; })));
        product.map(function (prod, i) {
            var prodRecord = {
                currentPeriod: "",
                product: prod,
                grossRevenue: 0,
                sbPassout: 0,
                refund: 0,
                financeCost: 0,
                netRevenue: 0,
                previousNrOne: 0,
                previousNrTwo: 0,
                previousPeriodOne: "",
                previousPeriodTwo: "",
                productSort: 0,
                subProductSort: 0,
                subProductList: [],
            };
            result.push(prodRecord);
        });
        result = result.map(function (clientRecords) {
            var clientList = data
                .filter(function (item) { return item.product === clientRecords.product; })
                .map(function (record) {
                clientRecords.grossRevenue += record.grossRevenue;
                clientRecords.sbPassout += record.sbPassout;
                clientRecords.refund += record.refund;
                clientRecords.financeCost += record.financeCost;
                clientRecords.netRevenue += record.netRevenue;
                clientRecords.previousNrOne += record.previousNrOne;
                clientRecords.previousNrTwo += record.previousNrTwo;
                clientRecords.currentPeriod = record.currentPeriod;
                clientRecords.previousPeriodOne = record.previousPeriodOne;
                clientRecords.previousPeriodTwo = record.previousPeriodTwo;
                clientRecords.productSort = record.productSort;
                clientRecords.subProductSort = record.subProductSort;
                return record;
            });
            clientRecords.subProductList = req.isSorting
                ? applySorting(req.sortRecord.key === "product"
                    ? __assign(__assign({}, req.sortRecord), { key: "subProduct" }) : req.sortRecord, clientList)
                : clientList;
            return clientRecords;
        });
    }
    return applySorting(req.sortRecord, result);
};
var applySorting = function (sortRecord, data) {
    if ((sortRecord === null || sortRecord === void 0 ? void 0 : sortRecord.type) && (sortRecord === null || sortRecord === void 0 ? void 0 : sortRecord.type) === "string") {
        data = stringSort(data, sortRecord.key, sortRecord === null || sortRecord === void 0 ? void 0 : sortRecord.order);
    }
    else {
        data = sort(data, sortRecord.key, sortRecord === null || sortRecord === void 0 ? void 0 : sortRecord.order);
    }
    return data;
};
